import dayjs from "dayjs";
import React, { Component } from "react";
import { isNullOrUndefined } from "util";
import { s360ConfigService } from "../../Services/S360Config";

export default class MessageA97 extends Component {
  constructor() {
    super();
    this.state = {
      checkedState: [],
      actionDone: false,
      values: [],
    };
  }

  componentDidMount() {
    this.formatData(this?.props?.entry?.text_data?.options);
  }

  formatData = function (data) {
    let initialArray = [];
    initialArray = new Array(data?.length).fill(false);
    this.setState({ checkedState: initialArray });
  };

  onChangeHandler = (position, e) => {
    const { checkedState } = this.state;
    //hardlimit to set the maximum select option
    let { hardLimit } = this?.props?.entry?.text_data?.hardlimit;
    hardLimit = Math.floor(this?.props?.entry?.text_data?.hardlimit);
    if (checkedState.filter((i) => i).length >= hardLimit && e.target.checked)
      return;
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    this.setState({ checkedState: updatedCheckedState });

    //get the option value and stored in a state
    if (e.target.checked) {
      this.setState({ values: [...this.state.values, e.target.value] });
    } else {
      let index = this.state.values.indexOf(e.target.value.toString());
      this.state.values.splice(index, 1);
      this.setState({ values: this.state.values });
    }

    console.log(this.state.values, this.state.checkedState);
  };

  onSubmit = () => {
    console.log(JSON.stringify({ selectedOptions: this.state.values }));
    let dataToSend = JSON.stringify({ selectedOptions: this.state.values });
    this.props.actions.sendMessageWithCode(this.props.entry.keyword, {
      value: dataToSend,
      name: this.state.values.toString(),
    });
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // this.onMouseLeave({ "target": n[i]});
    }
    var a = document.getElementsByClassName("reason-checkbox");
    for (var i = 0; i < a.length; i++) {
      a[i].style.pointerEvents = "none";
      a[i].style.opacity = "0.5";
    }
  };

  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = {
      // background: s360ConfigService.config.designDetails.recieverMessageColor,
      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
      // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
      fontWeight: isNullOrUndefined(designDetials.senderFontWeight) ? 500 : 500,
    };
    return styleData;
    // return {
    //     background: s360ConfigService.config.designDetails.recieverMessageColor,
    //      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
    //      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
    //      color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //      marginLeft: '15px'
    //     }
  };

  render() {
    let data = this?.props?.entry?.text_data?.options;

    const { checkedState } = this.state;

    return (
      <div className="CheckBoxWithSubmit">
        <div className="CheckBoxContainer">
          {data.length === 0 ? (
            <p>No Options to display</p>
          ) : (
            data.map(({ name, value }, index) => (
              <div
                className={
                  checkedState[index]
                    ? "oneCheckOption-checked"
                    : "oneCheckOption"
                }
                style={{
                  border: "1px solid #CCC",
                  opacity:
                    !checkedState[index] &&
                    checkedState.filter((i) => i).length ===
                      parseInt(this?.props?.entry?.text_data?.hardlimit)
                      ? 0.5
                      : 1,
                  cursor:
                    !checkedState[index] &&
                    checkedState.filter((i) => i).length ===
                      parseInt(this?.props?.entry?.text_data?.hardlimit)
                      ? "not-allowed"
                      : "default",
                }}
                value={value}
                id={value}
                disabled={
                  !checkedState[index] &&
                  checkedState.filter((i) => i).length ===
                    parseInt(this?.props?.entry?.text_data?.hardlimit)
                }
                onClick={(e) =>
                  this.onChangeHandler(index, {
                    target: {
                      value: value,
                      checked: !checkedState[index],
                    },
                  })
                }
              >
                <input
                  className="reason-checkbox"
                  type="checkbox"
                  value={value}
                  id={value}
                  onChange={(e) => this.onChangeHandler(index, e)}
                  disabled={
                    !checkedState[index] &&
                    checkedState.filter((i) => i).length ===
                      parseInt(this?.props?.entry?.text_data?.hardlimit)
                  }
                  checked={checkedState[index]}
                ></input>
                <label className="checkbox-label">{name}</label>
              </div>
            ))
          )}
        </div>
        {this.props.isLastEntry && this.props.sentTimestamp && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs.unix(this.props.sentTimestamp).format("DD MMM h:mm a")}
          </div>
        )}
        <div className="s360-message-cotainer-received">
          <button
            disabled={this.props.disabled}
            className="s360-message-box-custom-a15-received"
            onClick={
              this.state.values.length === 0
                ? console.log("not selected")
                : this.onSubmit
            }
            onMouseEnter={this.onMouseEnterButton}
            onMouseLeave={this.onMouseLeaveButton}
            style={this.messageBoxSubmitStyle()}
          >
            {this.props.entry.data
              ? JSON.parse(this.props.entry.data).buttonText
              : "Submit"}
          </button>
        </div>
      </div>
    );
  }
}
